module.exports = __webpack_public_path__ + "stylesheets/different-devices_061d17c1a50768d41228978c2744f738.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/different-devices.less
// module id = Ir05
// module chunks = 153